import { render, staticRenderFns } from "./AdminSurveys.vue?vue&type=template&id=077dff44&scoped=true"
import script from "./AdminSurveys.vue?vue&type=script&lang=js"
export * from "./AdminSurveys.vue?vue&type=script&lang=js"
import style0 from "./AdminSurveys.vue?vue&type=style&index=0&id=077dff44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077dff44",
  null
  
)

export default component.exports